<template>
  <div class="container">
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Termometria</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/termometria/produto/lista' }">Listas de Produtos</el-breadcrumb-item>
          <el-breadcrumb-item>Preços</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>

    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Preços da Lista de Produtos da Termoteria</h1>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-table
          :data="lista"
          style="width: 100%"
          v-loading="loading"
          element-loading-text="Loading..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.7)" >
          <el-table-column prop="id" label="Id" width="60" sortable></el-table-column>
          <el-table-column prop="sge_cliente" label="Fabricante" width="105"></el-table-column>
          <el-table-column prop="cod_nbr" label="Cód NBR" width="115" sortable></el-table-column>
          <el-table-column prop="cod_fabricante" label="Cód Fabricante" width="160" sortable></el-table-column>
          <el-table-column prop="nome" label="Nome" min-width="350" sortable></el-table-column>
          <el-table-column prop="modelo" label="Modelo" width="140" sortable></el-table-column>
          <el-table-column prop="" label="Valor" width="110" align="right" header-align="right">
            <template slot-scope="scope">
              {{ scope.row.valor | currency }}
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    ></el-pagination>

  </div>
</template>

<script>
import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  data() {
    return {
      loading: true,
      lista: [],
      permissao: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      sortBy: 'nome',
      sortOrder: 'asc',
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.ler_termometria) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    const id = this.$route.params.id
    this.getDados(id)
  },
  methods: {
    async getDados(id) {
      try {
        this.loading = true;
        const response = await axios.get(`${url}/termometria-produto-lista-precos/${id}`, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.lista = response.data;
          this.total = response.data.total;
        }
      } catch (err) {
        console.error("Erro ao buscar clientes:", err);
      } finally {
        this.loading = false;
      }
    },
    async getDados2(id) {
      console.log(id)
      this.loading = true;
      try {
        const response = await axios.get(`${url}/termometria-cliente-paginado?page=${this.currentPage}&perPage=${this.pageSize}&sortBy=${this.sortBy}&sortOrder=${this.sortOrder}`, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          this.lista = response.data.data;
          this.total = response.data.total;
        }
      } catch (err) {
        console.error("Erro ao buscar clientes:", err);
      } finally {
        this.loading = false;
      }
    },


    handleCurrentChange(page) {
      this.currentPage = page;
      this.getDados();
    },
    handleSortChange(column) {
      this.sortBy = column.prop;
      this.sortOrder = column.order === 'ascending' ? 'asc' : 'desc';
      this.fetchData();
    },



  },
  filters: {
    currency(value) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
    },
  },
};
</script>

<style>
.container {
  padding-bottom: 60px;
}
.el-row-topo {
  margin-top: 10px;
}
</style>
